export const frequentServiceRouteShortNames = [];

export const multiPlatformStopIds = [];

export const cableCarStopIds = [];

export const ferryStopIds = ["59010611", "59010612", "59010613", "59010614"];

export const isFrequentRoute = (routeLabel) =>
  frequentServiceRouteShortNames.includes(routeLabel);
